import { HardDrive, Users } from 'lucide-react';

import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';

export interface FsDriveTypeProps {
  value: string;
  onValueChange: (value: string) => void;
  className?: string;
}

export default function FsDriveType(fsDriveTypeProps: FsDriveTypeProps) {
  const { value, onValueChange, className } = fsDriveTypeProps;
  return (
    <Tabs value={value} onValueChange={onValueChange} className={className}>
      <TabsList className={'grid w-fit grid-cols-2'}>
        <TabsTrigger value="MY_DRIVE" className="h-8">
          <HardDrive className="size-3.5" />
          <span className="hidden lg:block">Dysk</span>
        </TabsTrigger>
        <TabsTrigger value="SHARED_DRIVE" className="h-8">
          <Users className="size-3.5" />
          <span className="hidden lg:block">Udostępnione</span>
        </TabsTrigger>
      </TabsList>
    </Tabs>
  );
}
